import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import dynamic from 'next/dynamic';
import * as S from './Advertise.styles';
import { IconBox } from '@/components/UI/IconBox/IconBox.styles';
import { useResponsive } from '@/hooks/useResponsive';
import { useToggleOpenState } from '@/hooks/useToggleOpenState';
import { BottomSheet } from '@/components/UI/BottomSheet/BottomSheet';
import { Promotions } from '@/components/Ad/Promotions/Promotions';
import { Modal } from '@/components/UI/Modal';
import { CloseIcon } from '@/components/UI/Icons/Icons';
import { Button } from '@/components/UI/Button/Button';
import { AdPageTestIds } from '@/__e2e__/testIds/ad-page';
import { AdKind } from '@/api/types/common.types';

const PromotionFlow = dynamic(
  () =>
    import('@/components/Ad/Promotions/PromotionFlow').then(
      mod => mod.PromotionFlow
    ),
  { ssr: false }
);

export const Advertise = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { isDesktop } = useResponsive();
  const [isModalOpen, toggleModal] = useToggleOpenState();
  const [isPromotionFlowOpen, togglePromotionFlow] = useToggleOpenState();
  const [selectedType, setSelectedType] = useState<AdKind | null>(null);

  function handleSelectPromotionType(type: AdKind) {
    setSelectedType(type);
    toggleModal(false);
    togglePromotionFlow(true);
  }

  function renderModalContent(isBottomSheet = false) {
    return (
      <S.ModalWrapper $isBottomSheet={isBottomSheet}>
        <S.ModalHeader $isBottomSheet={isBottomSheet}>
          <S.ModalTitle>{t('pages.ad.select_service')}</S.ModalTitle>
          <Button
            appearance="transparent"
            hasPadding={false}
            onClick={toggleModal}
          >
            <CloseIcon
              width={isDesktop ? 20 : 15}
              height={isDesktop ? 20 : 15}
              fill={theme.palette.secondary.labels}
            />
          </Button>
        </S.ModalHeader>
        <Promotions onSelectPromotion={handleSelectPromotionType} />
      </S.ModalWrapper>
    );
  }

  return (
    <>
      <S.AdvertiseButton
        onClick={toggleModal}
        borderRadius={14}
        data-testid={AdPageTestIds.advertiseButton}
      >
        <IconBox $filename="chart.svg" /> {t('common.advertise')}
      </S.AdvertiseButton>
      {isDesktop ? (
        <Modal isOpen={isModalOpen} onClose={toggleModal} maxWidth={600}>
          {renderModalContent()}
        </Modal>
      ) : (
        <BottomSheet isOpen={isModalOpen} close={toggleModal}>
          {renderModalContent(true)}
        </BottomSheet>
      )}

      <PromotionFlow
        isOpen={isPromotionFlowOpen}
        toggle={togglePromotionFlow}
        type={selectedType}
      />
    </>
  );
};
